import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import { FormattedMessage } from 'react-intl';

import toComputerImg from "./images/toComputer.png";
import MobileNotSupportEventManger from './utils/events/mobileNotsupportEventManager';

function MobileNotSupport(props) {
  const { classes, shareUrl, shareTitle, shareText, description, platform } = props;
  const [isShowToast, triggerToast] = React.useState(false);
  const [mobileNotSupportEventManger, setMobileNotSupportEventManger] = React.useState(null);
  
  React.useEffect(() => {
    setMobileNotSupportEventManger(new MobileNotSupportEventManger(platform));
  }, []);

  React.useEffect(() => {
    if (mobileNotSupportEventManger){
      mobileNotSupportEventManger.sendLandedEvent();
    }
  }, [mobileNotSupportEventManger]);
  
  const urlSearchParams = new URLSearchParams(window.location.search);
  let shareUrlObj = new URL(`${window.location.origin}/webapp`);
  try{
    shareUrlObj = new URL(shareUrl);
  }catch(error){

  }

  let appLink = 'https://link.alfredcamera.app/store/webviewer_redirect';
  if(platform === 'webcamera'){
    appLink = 'https://link.alfredcamera.app/store/webcamera_redirect'
  }

  async function handleClick(){
    const shareData = {
      title: shareTitle,
      text: shareText,
      url: formatShareUrl()
    }
    const isSupportShareAPI = window.navigator && typeof window.navigator.share === 'function';
    if(isSupportShareAPI){
      try{
        await navigator.share(shareData)
      }catch(error){
        console.error(error)
      }
    }else{
      copy(shareData.url);
      triggerToast(true);
      setTimeout(()=>{
        triggerToast(false)
      }, 1500)
    }
    mobileNotSupportEventManger.sendShareBtnClickEvent();
  }

  function handleAppLinkClick(){
    mobileNotSupportEventManger.sendAppLinkClickEvent();
  }

  function formatShareUrl(){
    const shareUrlSearchParams = new URLSearchParams(shareUrlObj.search);
    shareUrlSearchParams.set('utm_medium', 'share');
    const utmSource = urlSearchParams.get("utm_source") || platform; 
    const utmCampaign = urlSearchParams.get("utm_campaign") || "mobileview_sharebtn"; 
    shareUrlSearchParams.set("utm_source", utmSource);
    shareUrlSearchParams.set("utm_campaign", utmCampaign);

    return `${shareUrlObj.protocol}//${shareUrlObj.host}${shareUrlObj.pathname}?${shareUrlSearchParams.toString()}`
  }

  function copy(shareData){
    const el = document.createElement('textarea');
    el.value = shareData;
    document.body.appendChild(el);

    if (navigator.userAgent.match(/ipad|ipod|iphone/i)) {
      // save current contentEditable/readOnly status
      var editable = el.contentEditable;
      var readOnly = el.readOnly;

      // convert to editable with readonly to stop iOS keyboard opening
      el.contentEditable = true;
      el.readOnly = true;

      // create a selectable range
      var range = document.createRange();
      range.selectNodeContents(el);

      // select the range
      var selection = window.getSelection();
      selection.removeAllRanges();
      selection.addRange(range);
      el.setSelectionRange(0, 999999);

      // restore contentEditable/readOnly to original state
      el.contentEditable = editable;
      el.readOnly = readOnly;
    } else {
      el.select();
    }

    document.execCommand('copy');
    document.body.removeChild(el);
  }


  return (
    <div className={classes.root}>
      <div className={classes.container}>
        <p className={classes.title}> 
          <FormattedMessage id="mobile_view_title" />
        </p>
        <img
          className={classes.img}
          width="285"
          height="154"
          src={toComputerImg}
          alt=""
        />
        <p
          className={classes.description}
          dangerouslySetInnerHTML={{
            // highlight http url
            __html: description.replace(/(http[^\s]*)/, "<b>$1</b>"),
          }}
        ></p>
        <button className={classes.shareBtn} onClick={handleClick}>
          <FormattedMessage id="mobile_view_share_btn" />
        </button>
        <a
          href={appLink}
          onClick={handleAppLinkClick}
          className={classes.shareLink}
        >
          <FormattedMessage id="mobile_view_to_app" />
        </a>
        {isShowToast && (
          <div className={classes.toastContainer}>
            <div className={classes.toast}>
              <FormattedMessage id="mobile_view_toast_copy" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

MobileNotSupport.propTypes = {
  shareUrl: PropTypes.string,
  shareTitle: PropTypes.string,
  shareText: PropTypes.string,
  description: PropTypes.string,
};

const styles = (theme) => ({
  root: {
    height: "100vh",
    display: "flex",
    alignItems: "center",
    flexWrap: 'wrap',
    overflow: 'auto'
  },
  title: {
    fontFamily: "Open Sans",
    fontWeight: 600,
    fontSize: "26px",
    lineHeight: "36px",
    textAlign: "center",
  },
  container: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    padding: 16,
    boxSizing: "border-box",
  },
  description: {
    maxWidth: 300,
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: "15px",
    lineHeight: "26px",
    textAlign: "center",
    color: "#757575",
  },
  img: {
    marginTop: 49,
    marginBottom: 24,
  },
  shareBtn: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 17,
    lineHeight: "23px",
    textAlign: "center",
    color: "#1A1A1A",
    background: "#FCC35D",
    borderRadius: "4px",
    width: "100%",
    maxWidth: "340px",
    height: 48,
    border: "none",
    cursor: "pointer",
    marginTop: 40,
    marginBottom: 24,
  },
  shareLink: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: 15,
    lineHeight: "20px",
    textAlign: "center",
    textDecorationLine: "underline",
    color: "#1A1A1A",
  },
  toastContainer: {
    position: "fixed",
    bottom: "16px",
    left: "0",
    width: "100vw",
    display: "flex",
    justifyContent: "center",
  },
  toast: {
    background: "rgba(26, 26, 26, 0.8)",
    borderRadius: 2,
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    fontSize: 12,
    textAlign: "center",
    color: "#FFFFFF",
    height: 32,
    padding: "8px 16px",
    boxSizing: "border-box",
  },
});

export default withStyles(styles)(MobileNotSupport);
